//
//
//
//
//
//
//
//
//
//

import { ref } from '@vue/composition-api'

export default {
  setup() {
    const switch1 = ref(true)

    return { switch1 }
  },
}
